const basicUpdateNameFunction = (name, index) => `${name} #${index + 1}`;

const asSystemRemark = (api, remark) => {
  return api.tx.system.remark(remark);
};
const asUtilityBatch = (api, calls) => {
  return api.tx.utility.batchAll(calls);
};
const mapAsSystemRemark = (api) => (remark) => asSystemRemark(api, remark);

export { asSystemRemark, asUtilityBatch, basicUpdateNameFunction, mapAsSystemRemark };
